/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Filter_MarketingInputs */

const en_directory_launch_filter_marketing = /** @type {(inputs: Directory_Launch_Filter_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing`)
};

const zh_directory_launch_filter_marketing = /** @type {(inputs: Directory_Launch_Filter_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`营销`)
};

/**
* | output |
* | --- |
* | "Marketing" |
*
* @param {Directory_Launch_Filter_MarketingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_filter_marketing = /** @type {((inputs?: Directory_Launch_Filter_MarketingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Filter_MarketingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_filter_marketing(inputs)
	return zh_directory_launch_filter_marketing(inputs)
});
export { directory_launch_filter_marketing as "directory.launch.filter_marketing" }